import React, { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import HomeService from "../../services/HomeService";
import { getContentLanguage } from "../../services/LangPrefs";
import { usePagesTranslation } from "../locales";
import {
    buildReadStoryPath,
    getHomeStoryRowId,
    getLocalizedStoryFromHomeStoryRo,
    truncateText,
} from "../browse-stories/storyRoUtils";

/** Publisher block: latest original stories with real `/read-story` permalinks. */
export default function LandingLatestStoriesSection() {
    const { t } = usePagesTranslation();
    const contentLanguage = getContentLanguage();
    const [items, setItems] = useState([]);

    useEffect(() => {
        let cancelled = false;
        HomeService.getStoriesPage({
            page: 0,
            pageSize: 5,
            language: contentLanguage,
        }).then((result) => {
            if (cancelled) return;
            const content = Array.isArray(result.content) ? result.content : [];
            setItems(content);
        });
        return () => {
            cancelled = true;
        };
    }, [contentLanguage]);

    if (!items.length) return null;

    return (
        <section className="pi-section" id="latest-stories" aria-labelledby="pi-latest-stories-title">
            <div className="pi-landing__inner">
                <header className="pi-section__head">
                    <p className="pi-section__kicker">
                        {t("stories.latest-kicker", "Original stories")}
                    </p>
                    <h2 className="pi-section__title" id="pi-latest-stories-title">
                        {t("stories.latest-heading", "Latest stories")}
                    </h2>
                    <p className="pi-section__subtitle">
                        {t(
                            "stories.latest-subtitle",
                            "Each puzzle on Puzzle Interact starts with an illustrated tale we write ourselves. Read a story, then play the matching crossword or word search.",
                        )}
                    </p>
                </header>
                <ul className="pi-latest-stories">
                    {items.map((row) => {
                        const id = getHomeStoryRowId(row);
                        const href = buildReadStoryPath(id);
                        if (!href) return null;
                        const { title, text } = getLocalizedStoryFromHomeStoryRo(row, contentLanguage);
                        const heading = (title || row?.templateTitle || "").trim();
                        if (!heading) return null;
                        return (
                            <li key={id} className="pi-latest-stories__item">
                                <RouterLink className="pi-latest-stories__title" to={href}>
                                    {heading}
                                </RouterLink>
                                <p className="pi-latest-stories__excerpt">
                                    {truncateText(text, 140)
                                        || t("stories.preview-empty", "Open the story for the full text.")}
                                </p>
                            </li>
                        );
                    })}
                </ul>
                <div className="pi-latest-stories__actions">
                    <RouterLink className="pi-about__cta" to="/stories">
                        {t("stories.back-list", "All stories")}
                    </RouterLink>
                    <RouterLink className="pi-about__cta" to="/storybook">
                        {t("stories.open-storybook", "Open the storybook shelf")}
                    </RouterLink>
                </div>
            </div>
        </section>
    );
}
